import gql from "graphql-tag";

export const FRAGMENT_PRODUCT = gql`
  fragment product on Product {
    id
    availableForSale
    compareAtPriceRange {
      minVariantPrice {
        amount
        currencyCode
      }
      maxVariantPrice {
        amount
        currencyCode
      }
    }
    productType
    descriptionHtml
    images(first: 10) {
      edges {
        node {
          id
          url
          altText
          width
          height
        }
      }
    }
    handle
    tags
    title
    priceRange {
      minVariantPrice {
        amount
        currencyCode
      }
      maxVariantPrice {
        amount
        currencyCode
      }
    }
    variants(first: 10) {
      edges {
        node {
          id
          title
          availableForSale
          compareAtPriceV2 {
            amount
            currencyCode
          }
          currentlyNotInStock
          priceV2 {
            amount
            currencyCode
          }
          quantityAvailable
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

// https://shopify.dev/docs/api/usage/search-syntax
export const GET_PRODUCTS_BY_FILTER = gql`
  query getProductsByFilter($filter: String!, $limit: Int = 100) {
    products(first: $limit, query: $filter) {
      nodes {
        ...product
      }
    }
  }
  ${FRAGMENT_PRODUCT}
`;

export const GET_PRODUCTS_BY_ID = gql`
  query getProductsById($ids: [ID!]!) {
    nodes(ids: $ids) {
      ...product
    }
  }
  ${FRAGMENT_PRODUCT}
`;

// base 64 encoded variant id eg btoa("gid://shopify/ProductVariant/xxxxxxxxx")
export const GET_VARIANT_STOCK_LEVEL = gql`
  query getVariantById($nodeId: ID!) {
    node(id: $nodeId) {
      ... on ProductVariant {
        id
        currentlyNotInStock
        availableForSale
        quantityAvailable
      }
    }
  }
`;
